import { useState } from 'react';
import { useQuery, GET_LIST, GET_MANY_REFERENCE } from 'react-admin';

import { GAME_OFFICE_TYPES } from '@hisports/common/src/constants';

export const useOffices = () => useQuery({
  type: GET_LIST,
  resource: 'offices',
  payload: {
    filter: {
      type: { nin: [...GAME_OFFICE_TYPES, 'Historical'] },
      isAssigner: true,
      _include: [{ relation: 'parent', scope: { fields: ['name'], scope: 'Tenant' } }],
      _scope: 'Tenant',
    },
    pagination: { page: 0, perPage: 9999 },
    sort: { field: ['parent.name', 'name'], order: ['ASC', 'ASC'] },
  }
});

export function useOfficeSelection(participantId) {
  const [ selection, setSelection ] = useState([]);

  const { data = [], ...props } = useQuery({
    type: GET_MANY_REFERENCE,
    resource: 'officialOffices',
    payload: {
      target: 'participants',
      id: participantId,
      pagination: { page: 0, perPage: 9999 },
      filter: {},
    }
  }, {
    enabled: participantId != null,
    onSuccess({ data }) {
      const officeIds = data.map(relation => relation.officeId);
      setSelection(officeIds);
    }
  })

  return { selection, ...props }
}
